import { useEffect, useRef, useState } from 'react';

/** "0:07", "2:14", "1:02:09": how long a call has lasted. */
function formatCallDuration(milliseconds: number): string {
  const seconds = Math.max(0, Math.floor(milliseconds / 1000));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const rest = String(seconds % 60).padStart(2, '0');
  return hours > 0 ? `${hours}:${String(minutes).padStart(2, '0')}:${rest}` : `${minutes}:${rest}`;
}

/** How long the call has lasted ("2:14"), counted from when it started; null out of a call. */
export function useCallDuration(inCall: boolean): string | null {
  const started = useRef<number | null>(null);
  const [now, setNow] = useState(() => Date.now());
  if (inCall && started.current === null) started.current = Date.now();
  if (!inCall) started.current = null;
  useEffect(() => {
    if (!inCall) return;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [inCall]);
  return started.current === null
    ? null
    : formatCallDuration(Math.max(now, started.current) - started.current);
}
